import dedent from 'dedent';

export const authorizationToDiscloseHealthInformation = {
  text: dedent`Authorization to Disclose Health Information — “I authorize Waterlily and Wealth Assurance Group, LLC, and any reinsurers or third-party service providers they designate, to receive, transmit and store my health information for the purpose of generating insurance quotes and preparing underwriting forms for up to 24 months from today. I understand I may revoke this authorization at any time by e-mailing hello@joinwaterlily.com except to the extent action has already been taken.”`,
  date: '2025-08-14',
  consentVersionDescription:
    'Authorization to Disclose Health Information in Policy Application - Updated 14 August 2025',
};

export const certificationOfTheAccuracyOfHealthInformationDisclosed = {
  text: dedent`I certify that the information provided in this policy application form is true, complete and accurate to the best of my knowledge. I understand that material misstatements or omissions may result in the denial of coverage or rescission of any policy issued.`,
  date: '2025-08-14',
  consentVersionDescription:
    'Certification of the Accuracy of Health Information Disclosed - Updated 14 August 2025',
};

export const electronicSignatureAndRecordsConsent = {
  text: dedent`1. Long-Term-Care Insurance Suitability & Best-Interest Disclosure
Waterlily and Wealth Assurance Group collect information about your income, assets, goals and health to help determine whether any recommended insurance product is suitable and in your best interest, as defined by applicable state regulations (NAIC Model #641 and #275; NY Reg 187). We will maintain copies of your information and any recommendation for at least 7 years and make them available to you or your state Department of Insurance upon request.



2. Electronic Signature & Records Consent
By selecting “I Agree” below, you:

- Consent to the use of electronic signatures and electronic records
- Confirm you have the hardware and software necessary to access PDFs and web pages
- Understand you may withdraw consent at any time by emailing hello@joinwaterlily.com

Need a paper copy? Paper copies are available on request at no charge.



I have read and agree to the above Electronic Signature & Records Consent`,
  date: '2025-08-14',
  consentVersionDescription: 'Electronic Signature and Records Consent - Updated 14 August 2025',
};

export const underwritingPriceEstimateAcknowledgment = {
  text: dedent`I understand this is an updated estimate and the final price depends on underwriting.`,
  date: '2025-09-06',
  consentVersionDescription: 'Underwriting Price Estimate Acknowledgment - Updated 06 September 2025',
};
